// src/pages/NewTrip.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createTrip } from '../services/tripService';
import './NewTrip.css';

const NewTrip = ({ user }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [formData, setFormData] = useState({
    title: '',
    country: '',
    city: '',
    start_date: '',
    end_date: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // 表單驗證
    if (!formData.title || !formData.country || !formData.city || 
        !formData.start_date || !formData.end_date) {
      setError('請填寫所有必填欄位');
      return;
    }

    if (new Date(formData.start_date) > new Date(formData.end_date)) {
      setError('結束日期不能早於開始日期');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const tripId = await createTrip(formData, user.uid);
      navigate(`/trip/${tripId}`);
    } catch (error) {
      setError('創建行程失敗，請再試一次');
      console.error('Error creating trip:', error);
    } finally {
      setLoading(false);
    }
  };

  const countries = [
    '台灣', '日本', '韓國', '中國', '泰國', '新加坡', '馬來西亞', 
    '越南', '菲律賓', '印尼', '美國', '加拿大', '英國', '法國', 
    '德國', '義大利', '西班牙', '澳洲', '紐西蘭'
  ];

  return (
    <div className="new-trip-container">
      <div className="new-trip-card">
        <h1>建立新行程</h1>
        
        {error && (
          <div className="error-message">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="new-trip-form">
          <div className="form-group">
            <label htmlFor="title">行程標題 *</label>
            <input
              type="text"
              id="title"
              name="title"
              value={formData.title}
              onChange={handleInputChange}
              placeholder="例如：東京五日遊"
              required
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="country">國家 *</label>
              <select
                id="country"
                name="country"
                value={formData.country}
                onChange={handleInputChange}
                required
              >
                <option value="">選擇國家</option>
                {countries.map(country => (
                  <option key={country} value={country}>
                    {country}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="city">城市 *</label>
              <input
                type="text"
                id="city"
                name="city"
                value={formData.city}
                onChange={handleInputChange}
                placeholder="例如：東京"
                required
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="start_date">開始日期 *</label>
              <input
                type="datetime-local"
                id="start_date"
                name="start_date"
                value={formData.start_date}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="end_date">結束日期 *</label>
              <input
                type="datetime-local"
                id="end_date"
                name="end_date"
                value={formData.end_date}
                onChange={handleInputChange}
                required
              />
            </div>
          </div>

          <div className="form-actions">
            <button 
              type="button" 
              onClick={() => navigate('/')}
              className="cancel-btn"
            >
              取消
            </button>
            <button 
              type="submit" 
              disabled={loading}
              className="submit-btn"
            >
              {loading ? '建立中...' : '建立行程'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default NewTrip;